import { TEAMS_PLATFORM_CF_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { RichValue, StringValue } from '../../../value/types.tsx';
import type { TransformedTeamField, TransformedTeamOption } from '../types.tsx';

const getTeamValue: StringValue<TransformedTeamField> = (field) => field.value?.name ?? '';

export const teamStringValueHandler = {
	[TEAMS_PLATFORM_CF_TYPE]: getTeamValue,
};

const getTeamRichValue: RichValue<TransformedTeamField, TransformedTeamOption> = (field) =>
	field.value ?? null;

export const teamRichValueHandler = {
	[TEAMS_PLATFORM_CF_TYPE]: getTeamRichValue,
};
